/**
 * Sentry Error Monitoring - Frontend Initialization
 * MUST be imported BEFORE React renders in main.tsx
 *
 * @see https://docs.sentry.io/platforms/javascript/guides/react/
 */
import * as Sentry from '@sentry/react';

const dsn = (import.meta as any).env?.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: (import.meta as any).env?.MODE || 'development',
    release: (import.meta as any).env?.VITE_APP_VERSION || '1.0.0',

    sendDefaultPii: true,

    // Performance: sample 20% in production, 100% in dev
    tracesSampleRate: (import.meta as any).env?.PROD ? 0.2 : 1.0,

    // Session Replay: capture 10% of sessions, 100% of sessions with errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
  });

  console.log('[Sentry] Frontend monitoring initialized');
}

export { Sentry };
export const isSentryEnabled = () => !!dsn;
